import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { TTSDispatch, TTSState } from '../redux/store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// Review if is worth to use this
export const useAppDispatch: () => TTSDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<TTSState> = useSelector